/** @format */

import Header from "../../components/home/header/header";
import BadNews from "../../assets/images/Badnews.png";
import SubmitButton from "../../components/atoms/submitbutton";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../constants";
import { useDispatch } from "react-redux";
import { registerSuccess, registerFailed } from "../../redux/auth";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { registerSchema } from "../../validations/register";
import { useState } from "react";
import {
  MainSection,
  ImageSection,
  Image,
  RegisterSection,
  Input,
} from "./styles";

type FormData = yup.InferType<typeof registerSchema>;

const Register = () => {
  const [isloading, setisloading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // using form hook to register

  const { register, handleSubmit, formState } = useForm<FormData>({
    resolver: yupResolver(registerSchema),
  });
  const { errors } = formState;

  const registerRequest = (data: any) => {
    setisloading(true);
    axios
      .post(`${API_URL}/register`, {
        email: data.email,
        password: data.password,
      })
      .then(function (response: any) {
        if (response.status === 200) {
          dispatch(registerSuccess(response.data.data));
          setisloading(false);
          navigate("/dashboard");
          return;
        }

        toast.error(response.message);
      })
      .catch(function (error) {
        setisloading(false);
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 400
        ) {
          toast.error(error?.response?.data?.message);
          dispatch(registerFailed());
          return;
        }
        toast.error(`Connection Failed`);
      });
  };

  return (
    <>
      <Header />
      <MainSection>
        <ImageSection>
          <Image>
            <img src={BadNews} alt="" />
          </Image>
        </ImageSection>
        <RegisterSection>
          <form onSubmit={handleSubmit(registerRequest)}>
            <h2 className="mb-5">Register</h2>
            <Input
              autoComplete="email"
              className="p-3"
              {...register("email")}
              type="email"
              placeholder="Email"
              name="email"
              width="100%"
            />
            {errors?.email && (
              <p className="text-xs mb-2 text-red-600">
                {errors.email?.message}
              </p>
            )}
            <Input
              autoComplete="password"
              className="p-3"
              {...register("password")}
              type="password"
              placeholder="Password"
              name="password"
              width={"100%"}
            />
            {errors?.password && (
              <p className="text-xs   text-red-600">
                {errors.password?.message}
              </p>
            )}
            <Input
              {...register("confirmPassword")}
              type="password"
              className="p-3"
              placeholder="Retype Password"
              name="confirmPassword"
              width="100%"
            />
            {errors?.confirmPassword && (
              <p className="text-xs   text-red-600">
                {errors.confirmPassword?.message}
              </p>
            )}

            <SubmitButton
              value={"Register"}
              isloading={isloading}
              width="19.6em"
            />

            <h5 className="mt-[1em] mb-[3em]">
              Already have an account? <br />
              <u className="bold">
                <Link to="/login">Sign in</Link>
              </u>
            </h5>
          </form>
        </RegisterSection>
      </MainSection>
    </>
  );
};

export default Register;
